export const SITE_URL = 'https://lapetitetable.app';

export const LOCALE_PATHS: Record<string, string> = {
  'pt-BR': '/',
  en: '/en',
  es: '/es',
  fr: '/fr'
};

export const PARTNER_PATHS: Record<string, string> = {
  'pt-BR': '/parceiros',
  en: '/en/partners',
  es: '/es/socios',
  fr: '/fr/partenaires'
};

export const GUIDE_PATHS: Record<string, string> = {
  'pt-BR': '/sistema-para-restaurantes',
  en: '/en/restaurant-management-system',
  es: '/es/sistema-para-restaurantes',
  fr: '/fr/logiciel-pour-restaurants'
};

const HREFLANG: Record<string, string> = { 'pt-BR': 'pt-br', en: 'en', es: 'es', fr: 'fr' };

const OG_IMAGES: Record<string, string> = {
  'pt-BR': '/og.png',
  en: '/og-en.png',
  es: '/og-es.png',
  fr: '/og-fr.png'
};

const OG_LOCALE: Record<string, string> = { 'pt-BR': 'pt_BR', en: 'en_US', es: 'es_ES', fr: 'fr_FR' };

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel: string, href: string, hreflang?: string) {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    if (hreflang) el.setAttribute('hreflang', hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applySeo(opts: { lang: string; title: string; description: string; paths?: Record<string, string>; ld?: Record<string, unknown> }) {
  const map = opts.paths ?? LOCALE_PATHS;
  const path = map[opts.lang] ?? '/';
  const url = SITE_URL + (path === '/' ? '/' : path);

  document.documentElement.lang = HREFLANG[opts.lang] ?? 'pt-br';
  document.title = opts.title;
  upsertMeta('name', 'description', opts.description);
  upsertLink('canonical', url);

  for (const [code, p] of Object.entries(map)) {
    upsertLink('alternate', SITE_URL + (p === '/' ? '/' : p), HREFLANG[code]);
  }
  upsertLink('alternate', SITE_URL + (map['pt-BR'] ?? '/'), 'x-default');

  upsertMeta('property', 'og:title', opts.title);
  upsertMeta('property', 'og:description', opts.description);
  upsertMeta('property', 'og:type', 'website');
  upsertMeta('property', 'og:url', url);
  const ogImage = SITE_URL + (OG_IMAGES[opts.lang] ?? '/og.png');
  upsertMeta('property', 'og:image', ogImage);
  upsertMeta('property', 'og:image:width', '1200');
  upsertMeta('property', 'og:image:height', '630');
  upsertMeta('property', 'og:locale', OG_LOCALE[opts.lang] ?? 'pt_BR');
  upsertMeta('property', 'og:site_name', 'La petite table');
  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:image', ogImage);

  let ld = document.getElementById('ld-json');
  if (!ld) {
    ld = document.createElement('script');
    ld.id = 'ld-json';
    ld.setAttribute('type', 'application/ld+json');
    document.head.appendChild(ld);
  }
  ld.textContent = JSON.stringify(opts.ld ?? {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'La petite table',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    offers: { '@type': 'Offer', price: '199', priceCurrency: 'BRL' },
    description: opts.description
  });
}
